"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function pureAssign(baseObject) {
    var updates = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        updates[_i - 1] = arguments[_i];
    }
    if (updates.length === 0) {
        return baseObject;
    }
    else if (updates.length === 1) {
        return simplePureAssign(baseObject, updates[0]);
    }
    else {
        return simplePureAssign(baseObject, assign.apply(void 0, [{}].concat(updates)));
    }
}
exports.default = pureAssign;
function simplePureAssign(baseObject, update) {
    for (var key in update) {
        if (Object.prototype.hasOwnProperty.call(update, key) &&
            (!(key in baseObject) || baseObject[key] !== update[key])) {
            return assign({}, baseObject, update);
        }
    }
    return baseObject;
}
// We need a non-arrow function to use the arguments array.
// tslint:disable:only-arrow-functions
var assign = Object.assign ||
    function (t) {
        for (var s = void 0, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) {
                    t[p] = s[p];
                }
            }
        }
        return t;
    };
// tslint:enable:only-arrow-functions
//# sourceMappingURL=index.js.map